import React, { useEffect, useState } from "react";
import { Clock, ArrowRight, MessageCircle } from "lucide-react";
import { SKOOL_URL } from "@/lib/salesClosed";

const SALES_CLOSE_AT = new Date("2026-10-01T13:00:00Z").getTime();

function compute(now) {
  const diff = Math.max(0, SALES_CLOSE_AT - now);
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff % 86400000) / 3600000),
    m: Math.floor((diff % 3600000) / 60000),
    s: Math.floor((diff % 60000) / 1000),
    done: diff === 0,
  };
}

const pad = (n) => String(n).padStart(2, "0");

export default function TopUrgencyBar() {
  const [t, setT] = useState(() => compute(Date.now()));

  useEffect(() => {
    const id = setInterval(() => setT(compute(Date.now())), 1000);
    return () => clearInterval(id);
  }, []);

  const handleClick = (e) => {
    if (t.done) {
      // After deadline → send to Skool to message Jacob
      window.open(SKOOL_URL, "_blank", "noopener,noreferrer");
      return;
    }
    e.preventDefault();
    const el = document.getElementById("tickets");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      // On pages without a #tickets section, send them to /early-access
      window.location.href = "/early-access";
    }
  };

  return (
    <div
      data-testid="top-urgency-bar"
      className="fixed top-0 inset-x-0 z-[60] bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white shadow-[0_2px_12px_rgba(220,38,38,0.35)] border-b border-red-800/50"
    >
      <button
        type="button"
        onClick={handleClick}
        data-testid="top-urgency-cta"
        className="group w-full h-11 md:h-12 flex items-center justify-center gap-2 md:gap-4 px-3 md:px-6 text-[11px] md:text-sm font-black uppercase tracking-widest hover:bg-red-600/40 transition-colors"
      >
        <span className="relative flex h-2 w-2 shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-300 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-300" />
        </span>

        {t.done ? (
          <span className="inline-flex items-center gap-2 text-yellow-200">
            <MessageCircle size={14} className="text-yellow-300" />
            Sales Closed · Message Coach Jacob on Skool
            <ArrowRight size={14} className="shrink-0 group-hover:translate-x-0.5 transition-transform" />
          </span>
        ) : (
          <>
            <span className="hidden sm:inline">Sales Close In</span>
            <span className="inline sm:hidden">Closes</span>
            <span
              className="inline-flex items-baseline gap-1.5 md:gap-2 tabular-nums text-yellow-300 tracking-tight"
              data-testid="top-urgency-time"
            >
              <span>{t.d}<span className="text-yellow-200/70 text-[9px] md:text-[10px] ml-0.5">D</span></span>
              <span className="text-yellow-200/40">·</span>
              <span>{pad(t.h)}<span className="text-yellow-200/70 text-[9px] md:text-[10px] ml-0.5">H</span></span>
              <span className="text-yellow-200/40">·</span>
              <span>{pad(t.m)}<span className="text-yellow-200/70 text-[9px] md:text-[10px] ml-0.5">M</span></span>
              <span className="text-yellow-200/40">·</span>
              <span>{pad(t.s)}<span className="text-yellow-200/70 text-[9px] md:text-[10px] ml-0.5">S</span></span>
            </span>
            <span className="hidden md:inline text-white/90">Reserve now</span>
            <ArrowRight size={14} className="shrink-0 group-hover:translate-x-0.5 transition-transform hidden sm:inline" />
          </>
        )}
      </button>
    </div>
  );
}
